<gs-app-menu-panel [items]="items" />
